/* tslint:disable */

declare var Object: any;
export interface SFShiftScheduleInterface {
  "id"?: number;
}

export class SFShiftSchedule implements SFShiftScheduleInterface {
  "id": number;
  constructor(data?: SFShiftScheduleInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFShiftSchedule`.
   */
  public static getModelName() {
    return "SFShiftSchedule";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFShiftSchedule for dynamic purposes.
  **/
  public static factory(data: SFShiftScheduleInterface): SFShiftSchedule{
    return new SFShiftSchedule(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFShiftSchedule',
      plural: 'SFShiftSchedules',
      path: 'SFShiftSchedules',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFShiftSchedule.ts